export default __webpack_public_path__ + "static/Case-Study-Skyline-Enterprises-c65dab1db00dba7c6ebbb53d253e0e28.pdf";